// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g5RY","content":"styles_content__5Ebrj","row":"styles_row__1Q8in","footer":"styles_footer__2atx3","phraseLength":"styles_phraseLength__2sS0a"};